module.exports = __webpack_public_path__ + "static/media/IMG_7040.840b0079.jpg";